import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Camera = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <g clipPath="url(#a)">
        <path d="M3.668 2.71H2a.333.333 0 1 1 0-.667h1.667a.333.333 0 0 1 0 .667Z" />
        <path d="M14 15.043H2a1.669 1.669 0 0 1-1.666-1.666v-8A1.669 1.669 0 0 1 2.001 3.71h2.806l1.238-2.166a.333.333 0 0 1 .289-.167h4a.333.333 0 0 1 .29.167L11.86 3.71H14a1.669 1.669 0 0 1 1.667 1.667v8A1.668 1.668 0 0 1 14 15.043ZM2 4.377a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-2.333a.334.334 0 0 1-.29-.167L10.14 2.044H6.527L5.29 4.21a.333.333 0 0 1-.29.167H2Z" />
        <path d="M8.335 5.71a3.667 3.667 0 1 1 0 7.334 3.667 3.667 0 0 1 0-7.333Zm0 6.667a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3 5.71a.667.667 0 1 1 0 1.334.667.667 0 0 1 0-1.333Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M0 .379h16v15.999H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

Camera.category = 'product-category';

Camera.displayName = 'Camera';
